import React from 'react'
import { FieldProps, GenderString } from '../../../../../../../@types/types'
import { WhoWeLookForScreenValidationResult } from '../../../../../../../@types/validation-types'
import ChipOptionField from '../../../../../../common/inputs/chipOptionField/ChipOptionField'

const RequestedGender: React.FC<FieldProps<WhoWeLookForScreenValidationResult>> = ({
  insertionData,
  validationMessages,
  onChange,
  screenName,
}) => {
  return (
    <div id='requested-gender-container'>
      <ChipOptionField
        id='requested-gender'
        propertyName='requestedGender'
        translation='wizard.screen.whoWeLookFor.requestedGender.'
        labelTranslationKey='wizard.screen.whoWeLookFor.labels.requestedGender'
        option={insertionData.requestedGender}
        options={GenderString}
        isFirstChipFiltered={false}
        errors={validationMessages?.requestedGender ?? []}
        enableDeselection={false}
        onChange={(value) => onChange({ screen: screenName, property: 'requestedGender' }, value)}
      />
    </div>
  )
}

export default RequestedGender
